import { motion } from 'framer-motion';

const Hero = () => {
  const titleLines = ['SMALL', 'STUDIO', 'BIG', 'IDEAS'];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.3,
      },
    },
  };

  const lineVariants = {
    hidden: { y: 100, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <section
      data-testid="hero-section"
      className="relative h-screen supports-[height:100svh]:h-[100svh] w-full flex items-center justify-center overflow-hidden bg-[#050505]"
    >
      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 pt-20 md:pt-24 w-full max-w-7xl mx-auto">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="text-center"
        >
          {/* Main Title */}
          <h1 className="overflow-hidden mb-8 font-heading font-black text-[length:clamp(3rem,min(15vw,16vh),10rem)] leading-[0.85] tracking-tight text-shadow">
            {titleLines.map((line, index) => (
              <motion.span
                key={line}
                variants={lineVariants}
                className="block"
                data-testid={`hero-title-${index}`}
              >
                {line}
              </motion.span>
            ))}
          </h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.6 }}
            className="font-body text-sm md:text-base tracking-[0.3em] text-white/60 uppercase"
            data-testid="hero-subtitle"
          >
            Audio Specialist and Music Consulting
          </motion.p>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.8 }}
        className="absolute bottom-12 left-1/2 -translate-x-1/2 hidden md:block"
        aria-hidden="true"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="w-6 h-10 border border-white/30 rounded-full flex items-start justify-center p-2"
        >
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1 h-2 bg-white/60 rounded-full"
          />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
